import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
import { getFallbackValueIfNull } from 'owa-options-core';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isConversationsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var listViewTypeSelected = getFallbackValueIfNull(optionState.globalListViewType, userOptions.GlobalListViewTypeReact);
    var conversationSortOrder = getFallbackValueIfNull(optionState.conversationSortOrder, userOptions.ConversationSortOrderReact);
    var hideDeletedItems = getFallbackValueIfNull(optionState.hideDeletedItems, userOptions.HideDeletedItems);
    return (listViewTypeSelected !== userOptions.GlobalListViewTypeReact ||
        conversationSortOrder !== userOptions.ConversationSortOrderReact ||
        hideDeletedItems !== userOptions.HideDeletedItems);
});
//# sourceMappingURL=isConversationsOptionDirty.js.map